import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import axiosClient from "../api/axiosClient";
import { useNavigate } from "react-router-dom";
import "../Register.css";

const VerifyOtp = () => {
  const location = useLocation();
  const { phoneNumber } = location.state || {}; // Retrieve phone number from state

  const [otp, setOtp] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!otp) {
      setMessage("Please enter the OTP sent to your phone.");
      return;
    }
    try {
      const response = await axiosClient.post("/user/verify_otp/", {
        phone_number: phoneNumber, // Automatically included
        otp, // User inputs this
      });
      setMessage("OTP verified successfully!");
      localStorage.setItem("access_token", response.data.tokens.access);
      localStorage.setItem("refresh_token", response.data.tokens.refresh);
      localStorage.setItem("user_id", response.data.user.id);
      navigate("/dashboard");
    } catch (error) {
      setMessage(error.response?.data?.message || "Verification failed.");
    }
  };

  const handleRegenerateOtp = async (e) => {
    e.preventDefault();
    try {
      await axiosClient.post("/user/regenerate_otp/", {
        phone_number: phoneNumber,
      });
      setMessage("OTP has been regenerated and sent to your phone.");
    } catch (error) {
      setMessage(error.response?.data?.message || "Failed to regenerate OTP.");
    }
  };

  const handleGoHome = () => {
    navigate("/"); // Navigate to the register page
  };

  return (
    <div className="page-container">
      <img src="/new_logo.png" alt="Logo" className="logo" />
      <h1 className="title">Verify OTP</h1>
      {phoneNumber ? (
        <>
          <text className="subheading">Please enter the 6 Digit OTP Sent To:</text>
          <p className="subheading">{phoneNumber}</p>
          <form onSubmit={handleSubmit} className="form">
            <input
              type="text"
              name="otp"
              placeholder="Enter OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              className="input_otp"
              required
            />
            <div className="verify_buttons_container">
            <button type="submit" className="verify-otp-button">
              Confirm
            </button>
            <button
              type="button"
              onClick={handleRegenerateOtp}
              className="verify-otp-button"
            >
              Resend
            </button>
            </div>
          </form>
        </>
      ) : (
        <p className="error">Phone number not provided. Please go back to register.</p>
      )}
      <button
        onClick={handleGoHome}
        className="small-button"
      >
        Go Back
      </button>
      {message && <p className="error">{message}</p>}
    </div>
  );
};

export default VerifyOtp;
